module.exports = __webpack_public_path__ + "static/media/casting_jerry.d98d9cde.jpg";